module.exports = __webpack_public_path__ + "img/add-user.6426b255.svg";